export const SlotManagementConfigQueryKey = 'slotManagementConfigs'

export const ProductConfigsQueryKey = 'product-configs'
